import React, { useState } from 'react';
import { ArrowRight, Clock, Users, TrendingUp, Zap, Shield, Database, Cloud, } from 'lucide-react';

const ServicesGrid = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const services = [
  {
  id: 1,
  type: 'hero',
  category: "Enterprise Solutions",
  title: "SAP Transformation & Migration",
  description: "Accelerate your digital evolution with seamless SAP migration, system upgrades, and end-to-end transformation strategies.",
  image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&h=400&fit=crop",
  icon: Database,
  stats: "200+ SAP Projects Experiences",
  size: "large"
},
{
  id: 2,
  type: 'feature',
  category: "ERP Solutions",
  title: "SAP S/4HANA Implementation",
  description: "Streamline operations and gain real-time insights with a tailored SAP S/4HANA implementation strategy that meets your business needs.",
  icon: TrendingUp,
  gradient: "from-blue-500 to-blue-500",
  size: "medium"
},
{
  id: 3,
  type: 'image-card',
  category: "User Experience",
  title: "SAP Fiori UX Design",
  description: "Enhance productivity and user satisfaction through intuitive, role-based SAP Fiori apps tailored to your workflows.",
  image: "https://community.sap.com/legacyfs/online/storage/blog_attachments/2022/05/ScreenCollection-iOS.png",
  author: "UX Team",
  duration: "4–6 weeks",
  size: "medium"
},
{
  id: 4,
  type: 'compact',
  title: "SAP MDG",
  description: "Ensure enterprise-wide data consistency, accuracy, and compliance with SAP Master Data Governance solutions.",
  icon: Shield,
  color: "green",
  size: "small"
},
{
  id: 5,
  type: 'feature',
  category: "Technology & Innovation",
  title: "SAP BTP",
  description: "Unlock agility and innovation with SAP BTP—integrate, extend, and build intelligent applications across your SAP landscape.",
  icon: Cloud, // Replacing 'Cloud' with something symbolizing innovation/acceleration
  gradient: "from-purple-400 to-indigo-600",
  size: "medium"
},
{
  id: 6,
  type: 'image-card',
  category: "Digital Procurement",
  title: "SAP Ariba",
  description: "Optimize sourcing, contract management, and supplier collaboration with SAP Ariba’s cloud-based procurement solutions.",
  image: "https://peakin.in/wp-content/uploads/2023/08/4-1.jpg",
  author: "Procurement Team",
  duration: "3–5 months",
  size: "large"
},
{
  id: 7,
  type: 'compact',
  category: "Intelligent Insights",
  title: "SAP Automation & Analytics",
  description: "Empower data-driven decisions with intelligent automation and real-time analytics across your SAP ecosystem.",
icon: TrendingUp,
  color: "orange",
  size: "small"
},
{
  id: 8,
  type: 'hero',
  category: "Customer Relationship Management",
  title: "Salesforce CRM Implementation",
  description: "Deliver seamless Salesforce CRM implementations with tailored configurations, third-party integrations, and user enablement.",
  image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTC8tgeDcYtezt1igXtlWcIHvo6hRw_rKYhbQ&s",
  icon: Users, // Still relevant for CRM; could also consider UserGroup or UserCheck
  stats: "95% Success Rate",
  size: "large"
},
{
  id: 9,
  type: 'image-card',
  category: "Modern Workplace",
  title: "Microsoft O365 Implementation",
  description: "Enable a modern, collaborative workplace with seamless deployment, configuration, and user adoption of Microsoft 365 tools.",
  image: "https://www.lifewire.com/thmb/r8g0i7BWh6hhbAqJ7n30bcMdpT0=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/001-a-complete-guide-to-microsoft-office-fe6077e048334d9aa96cdf604995c9d8.jpg",
  author: "Cloud Team",
  duration: "2–4 weeks",
  size: "medium"
},
{
  id: 10,
  type: 'feature',
  category: "Data & Analytics",
  title: "Data & Analytics",
  description: "Transform raw data into actionable insights using advanced analytics, AI-driven models, and dynamic visualizations.",
  icon: Database,
  gradient: "from-emerald-400 to-teal-600",
  size: "large"
},
{
  id: 4,
  type: 'compact',
  title: "CX Services",
  description: "Enhance customer engagement and loyalty with personalized experiences and seamless multi-channel interactions.",
  icon: Shield,
  color: "blue",
  size: "small"
},
{
  id: 11,
  type: 'compact',
  category: "Software Development",
  title: "DevOps",
  description: "Accelerate software delivery through continuous integration, continuous deployment (CI/CD), and automation best practices.",
  icon: Zap,
  color: "blue",
  size: "small"
},
{
  id: 12,
  type: 'feature',
  category: "Cloud Services",
  title: "Cloud Migration & Optimization",
  description: "Ensure seamless cloud migration with strategies focused on cost efficiency, scalability, and performance optimization.",
  icon: Cloud,
  gradient: "from-red-400 to-red-700",
  size: "medium"
},
{
  id: 13,
  type: 'compact',
  category: "Security Solutions",
  title: "Custom Solutions",
  description: "Tailored security strategies and technologies designed to safeguard your critical digital assets and infrastructure.",
  icon: Shield,
  color: "red",
  size: "small"
},
{
  id: 14,
  type: 'image-card',
  category: "Mobile Development",
  title: "Mobile Application Development",
  description: "Design and develop innovative, high-performance mobile apps for iOS and Android using the latest technologies and frameworks.",
  image: "https://images.unsplash.com/photo-1639609546646-d3935a52717c?q=80&w=1071&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  author: "Mobile Team",
  duration: "3–6 months",
  size: "large"
},

  ];

  const HeroCard = ({ service }) => (
    <div
      onMouseEnter={() => setHoveredCard(service.id)}
      onMouseLeave={() => setHoveredCard(null)}
      className="relative rounded-2xl overflow-hidden shadow-xl cursor-pointer bg-white group transform transition-all duration-300 hover:-translate-y-2"
    >
      <div className="relative h-72">
        <img
          src={service.image}
          alt={service.title}
          width="400"
          height="288"
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
        
        <div className="absolute top-6 left-6">
          <span className="px-3 py-1.5 text-xs font-semibold bg-white/90 backdrop-blur-sm text-gray-900 rounded-full">
            {service.category}
          </span>
        </div>
        
        <div className="absolute bottom-6 left-6 right-6">
          <div className="flex items-center mb-3">
            <service.icon className="w-6 h-6 text-white mr-2" />
            <span className="text-white/80 text-sm font-medium">{service.stats}</span>
          </div>
          <h3 className="text-white font-bold text-xl mb-3 leading-tight">
            {service.title}
          </h3>
          <p className="text-white/90 text-sm leading-relaxed ">
            {service.description}
          </p>
    
        </div>
      </div>
    </div>
  );

  const FeatureCard = ({ service }) => (
    <div
      onMouseEnter={() => setHoveredCard(service.id)}
      onMouseLeave={() => setHoveredCard(null)}
      className={`bg-gradient-to-br ${service.gradient} rounded-2xl p-8 text-white shadow-xl cursor-pointer transform transition-all duration-300 hover:-translate-y-2 relative overflow-hidden`}
    >
      <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
      <div className="relative z-10">
        <div className="flex items-center mb-4">
          <service.icon className="w-8 h-8 mr-3" />
          <span className="text-sm font-semibold opacity-90">{service.category}</span>
        </div>
        <h3 className="font-bold text-lg mb-2 leading-tight">
          {service.title}
        </h3>
        <p className="text-white/90 text-sm leading-relaxed ">
          {service.description}
        </p>
       
      </div>
    </div>
  );

  const ImageCard = ({ service }) => (
    <div
      onMouseEnter={() => setHoveredCard(service.id)}
      onMouseLeave={() => setHoveredCard(null)}
      className="bg-white rounded-2xl overflow-hidden shadow-lg cursor-pointer transform transition-all duration-300 hover:-translate-y-2"
    >
      <div className="relative h-48">
        <img
          src={service.image}
          alt={service.title}
          width="400"
          height="192"
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 left-4">
          <span className="px-3 py-1 text-xs font-semibold bg-white/90 backdrop-blur-sm text-gray-900 rounded-full">
            {service.category}
          </span>
        </div>
      </div>
      <div className="p-6">
        <h3 className="font-bold text-gray-900 mb-2 leading-tight">
          {service.title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed mb-3">
          {service.description}
        </p>
        <div className="flex items-center justify-between text-xs text-gray-500">
          <div className="flex items-center">
            <Users className="w-4 h-4 mr-1" />
            <span>{service.author}</span>
          </div>
          <div className="flex items-center">
            <Clock className="w-4 h-4 mr-1" />
            <span>{service.duration}</span>
          </div>
        </div>
      </div>
    </div>
  );

  const CompactCard = ({ service }) => {
    const colorClasses = {
      blue: 'from-sky-400 to-blue-500', //sap S/4HANA
      green: 'from-lime-500 to-green-600', //SAP MDG
      orange: 'from-pink-400 to-orange-600',  //SAP Automation & Analytics
      red: 'from-yellow-400 to-red-400' //Custom Solutions
    };

    return (
      <div
        onMouseEnter={() => setHoveredCard(service.id)}
        onMouseLeave={() => setHoveredCard(null)}
        className={`bg-gradient-to-br ${colorClasses[service.color]} rounded-2xl p-6 text-white shadow-lg cursor-pointer transform transition-all duration-300 hover:-translate-y-2`}
      >
        <div className="flex items-center mb-3">
          <service.icon className="w-6 h-6 mr-3" />
          <h3 className="font-bold text-lg">{service.title}</h3>
        </div>
        <p className="text-white/90 text-sm leading-relaxed">
          {service.description}
        </p>
      </div>
    );
  };

  const renderCard = (service) => {
    switch (service.type) {
      case 'hero':
        return <HeroCard key={service.id} service={service} />;
      case 'feature':
        return <FeatureCard key={service.id} service={service} />;
      case 'image-card':
        return <ImageCard key={service.id} service={service} />;
      case 'compact':
        return <CompactCard key={service.id} service={service} />;
      default:
        return <ImageCard key={service.id} service={service} />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-18 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">
            Our <span className="text-blue-600">Services</span>
          </h2>
          <p className="text-md text-gray-600 max-w-3xl mx-auto">
            Transforming businesses with cutting-edge technology solutions and comprehensive service offerings.
          </p>
        </div>

        {/* Masonry Grid */}
        <div className="columns-1 md:columns-2 lg:columns-3 xl:columns-4 gap-6 space-y-6">
          {services.map((service) => (
            <div key={service.id} className="break-inside-avoid">
              {renderCard(service)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesGrid;